<!--图片加载组件-->
<template>
  <portal to="local-loading">
    <div class="local-loading-overlay">
      <img :src="loadingImg" class="local-loading-img" />
    </div>
  </portal>
</template>

<script>
export default {
  name: "PictureLoading",
  data() {
    return {
      // 用 BASE_URL(=publicPath=/contract/) 前缀引用 public 静态资源，避免 history 路由下相对路径 404
      loadingImg: process.env.BASE_URL + 'images/loading-load.gif',
    };
  }
}
</script>

<style scoped>
/* 遮罩层：absolute 相对于 #local-dialog-container 定位 */
.local-loading-overlay {
  position: absolute;
  /* ← 关键：不能用 fixed */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* 建议加半透明背景，否则遮罩无视觉反馈 */
  z-index: 9999;
  display: flex;
  /* 用 flex 居中替代 margin-left/margin-top 百分比 hack */
  align-items: center;
  justify-content: center;
}

.local-loading-img {
  width: 85px;
  /* 不再需要 margin-left:50% / margin-top:18% */
}
</style>
